import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { postAuthLogin } from "../../services/api";
import { deleteToken, getToken, setCookie } from "../../services/cookies";
import { useTranslation } from "react-i18next";
import "../../i18n";

const Login = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const { from, groupId, userId } = location.state || {};

  const { t, i18n } = useTranslation();

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  // Token kontrolü - eğer kullanıcı zaten giriş yapmışsa yönlendir
  const checkLogin = async () => {
    // const token = getToken("qriendtoken");
    // if (token) {
    //   // Token varsa kullanıcı zaten giriş yapmış, anasayfaya yönlendir
    //   navigate("/", { replace: true });
    // }
  };

  useEffect(() => {
    checkLogin();
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    const data = {
      email: email,
      password: password,
      rememberMe: false,
    };

    try {
      console.log(data);
      const response = await postAuthLogin(data);
      console.log(response);

      if (response && response.token) {
        deleteToken("qriendtoken");
        setCookie(response.token);
        localStorage.setItem("name", response.user.name);

        // Yönlendirme işlemi
        if (from) {
          navigate(from, {
            state: {
              isLoggedIn: true,
              groupId: groupId,
              userId: userId,
            },
            replace: true,
          });
        } else {
          navigate("/", { replace: true });
        }

        // // Sayfayı yenile
        // window.location.reload();
      }
    } catch (err) {
      setError(
        err?.response?.data?.message ||
          err?.message ||
          "Giriş başarısız. Lütfen bilgilerinizi kontrol edin."
      );
      console.error("Login error:", err);
    } finally {
      setLoading(false);
    }
  };

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   setError("");
  //   setLoading(true);
  //   const data = {
  //     email,
  //     password,
  //     rememberMe: true,
  //   };
  //   try {
  //     // login fonksiyonu: { email, password } alır ve token/user döndürür
  //     const response = await login({ email, password, rememberMe: true });

  //     // Kullanıcı ID'sini ve token'ı localStorage'a kaydet
  //     if (response.user && response.user.id) {
  //       localStorage.setItem("userId", response.user.id);
  //       localStorage.setItem("user", JSON.stringify(response.user));
  //     }

  //     // Token'ı cookie'ye kaydet (setCookie fonksiyonu aracılığıyla 'qriendtoken' olarak)
  //     if (response.token) {
  //       setCookie(response.token);
  //     }

  //     if (from) {
  //       navigate(from, {
  //         state: {
  //           isLoggedIn: true,
  //           groupId: groupId,
  //           userId: userId,
  //         },
  //         replace: true,
  //       });
  //     } else {
  //       navigate("/", { replace: true });
  //     }
  //     // Sayfayı yenile
  //     window.location.reload();
  //   } catch (err) {
  //     setError(
  //       err?.response?.data?.message ||
  //         err?.message ||
  //         "Giriş başarısız. Lütfen bilgilerinizi kontrol edin."
  //     );
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  return (
    <div className="flex min-h-screen mx-auto bg-white">
      {/* Sol taraf - Resim */}
      <div className="hidden lg:flex w-[55%] relative h-screen overflow-visible">
        <div className="w-full h-full flex justify-center items-center overflow-visible">
          <div className="relative w-full h-full overflow-visible">
            <div className="w-full h-full rounded-2xl">
              <img
                src="/assets/loginPageImg2.png"
                alt="Profil"
                className="object-contain w-full h-full rounded-2xl p-4"
              />
            </div>
          </div>
        </div>
      </div>

      {/* Sağ taraf - Form */}
      <div className="w-full lg:w-[45%] flex flex-col justify-center items-center">
        <Link to="/">
          <img
            src="/assets/qriendLogoRedNew.png"
            alt="QRiend Logo"
            className="w-56 h-28"
          />
        </Link>
        <div className="w-full max-w-md">
          <h1 className="text-[30px] text-black font-poppins font-semibold mb-2 text-center font-plus-jakarta-sans">
            {t("welcome")}
          </h1>

          <p className="text-[#96A0AD]  max-w-96 font-poppins text-center text-[14px] font-plus-jakarta-sans font-normal mb-6">
            {t("welcomeDesc")}
          </p>

          {/* Hata mesajı */}
          {error && (
            <div className="mb-4 p-3 bg-red-100 text-red-600 rounded-lg text-sm text-center">
              {error}
            </div>
          )}

          {/* Giriş formu */}
          <form onSubmit={handleSubmit}>
            <div className="mb-3 pl-4 pr-4 lg:pl-0 lg:pr-0">
              <input
                type="email"
                className="w-full p-3 border bg-white border-gray-300 rounded-lg font-plus-jakarta-sans text-base text-black"
                placeholder={t("email")}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                disabled={loading}
              />
            </div>

            <div className="mb-3 pl-4 pr-4 lg:pl-0 lg:pr-0">
              <div className="relative">
                <input
                  type={showPassword ? "text" : "password"}
                  className="w-full p-3 border bg-white border-gray-300 rounded-lg font-plus-jakarta-sans text-base text-black"
                  placeholder={t("password")}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  disabled={loading}
                />
                <button
                  type="button"
                  className="absolute inset-y-0 right-0 pr-3 flex items-center"
                  onClick={togglePasswordVisibility}
                  tabIndex={-1}
                >
                  {showPassword ? (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth={1.5}
                      stroke="currentColor"
                      className="w-6 h-6 text-gray-500"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M3.98 8.223A10.477 10.477 0 0 0 1.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.451 10.451 0 0 1 12 4.5c4.756 0 8.773 3.162 10.065 7.498a10.522 10.522 0 0 1-4.293 5.774M6.228 6.228 3 3m3.228 3.228 3.65 3.65m7.894 7.894L21 21m-3.228-3.228-3.65-3.65m0 0a3 3 0 1 0-4.243-4.243m4.242 4.242L9.88 9.88"
                      />
                    </svg>
                  ) : (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth={1.5}
                      stroke="currentColor"
                      className="w-6 h-6 text-gray-500"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z"
                      />
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
                      />
                    </svg>
                  )}
                </button>
              </div>
            </div>

            <div className="flex justify-between items-center my-8 pl-4 pr-4 lg:pl-0 lg:pr-0">
              <div className="flex items-center">
                <input
                  type="checkbox"
                  defaultChecked
                  className="checkbox checkbox-error !text-white"
                />
                <label
                  htmlFor="remember"
                  className="text-sm font-plus-jakarta-sans font-normal text-black font-poppins ml-2"
                >
                  {t("rememberMe")}
                </label>
              </div>
              <a
                href="/forgot-password"
                className="text-[#E94057] text-sm font-plus-jakarta-sans font-normal  font-poppins"
              >
                {t("forgotPassword")}
              </a>
            </div>

            <div className="pl-4 pr-4 lg:pl-0 lg:pr-0">
              <button
                type="submit"
                className="w-full bg-gradient-to-r from-[#FA3091] to-[#E94057] text-white p-3 rounded-full font-plus-jakarta-sans text-lg font-semibold font-poppins"
                disabled={loading}
              >
                {loading ? "Giriş Yapılıyor..." : t("login")}
              </button>
            </div>
          </form>

          <p className="text-center mt-4 text-base font-plus-jakarta-sans font-normal font-poppins text-black pt-8 pl-4 pr-4 lg:pl-0 lg:pr-0">
            {t("loginDesc")}{" "}
            <Link
              to="/register"
              className="text-[#E94057] text-base font-plus-jakarta-sans font-normal"
            >
              {t("loginReg")}
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;
